/*Canvas to blob polyfill*/
if (!HTMLCanvasElement.prototype.toBlob) {
	Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
		value: function (callback, type = 'image/png', quality) {
			setTimeout(() => {
				const binStr = atob(this.toDataURL(type, quality).split(',')[1]);
				const len = binStr.length;
				const arr = new Uint8Array(len);

				for (let i = 0; i < len; i++ ) {
					arr[i] = binStr.charCodeAt(i);
				}

				callback(new Blob([arr], {
					type
				}));
			});
		}
	});
}

/*
* @param {string} url - url of image to resize
* @param {object} options - object of options which will determine how resizing should be performed
* @param {number} options.width - width of the output image
* @param {number} options.height - height of the output image
* @param {string} options.mimeType - mime type of extension for image
*/

export default (url, options) => new Promise((resolve, reject) => {
	const img = document.createElement('img');

	img.crossOrigin = 'Anonymous';
	img.onload = function() {
		const tempCanvas = document.createElement('canvas');
		const ctx = tempCanvas.getContext('2d');
		const needsResize = img.width > options.width || img.height > options.height;

		const aspectRatio = Math.max(img.width / options.width, img.height / options.height);
		const width = needsResize ? img.width / aspectRatio : img.width;
		const height = needsResize ? img.height / aspectRatio : img.height;

		tempCanvas.width = width;
		tempCanvas.height = height;
		ctx.drawImage(img, 0, 0, width, height);

		tempCanvas.toBlob(resolve, options.mimeType);
	};
	img.onerror = function(err) {
		reject({
			imageResizeError: true,
			...err
		});
	};
	img.src = url;
});